import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=6432a5f6&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=6432a5f6&prod&lang=scss&scoped=true"
import style1 from "./faq.vue?vue&type=style&index=1&id=6432a5f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6432a5f6",
  null
  
)

export default component.exports